<template>
    <div id="page-case-studies">
        <div class="row">
            <div class="col-xl-5 col-12 p-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left px-xl-0 px-4">
                    {{ $t($route.meta.title) }}
                    <hr class="hr-title-mobile">
                </div>
            </div>

            <div class="col-xl-7 offset-xl-0 col-12 p-0">
                <div v-if="currentproject" class="h1 text-red labgrotesque-bold text-left px-xl-0 px-4 page-title">
                    <hr class="hr-title">
                    <span v-html="currentproject.title"></span>
                </div>
            </div>
        </div>

        <template>
            <template v-if="$root.getClassSize() == 'xl'">
                <div class="row mt-5" v-if="projects.length > 0">
                    <div class="col-xl-5 p-0">
                        <div class="row">
                            <div class="col-xl-6 pl-0 pr-2">
                                <div class="d-none d-xl-flex justify-content-end mr-3">
                                    <div v-for="(path, index) in currentproject.field_servizi_logo_2" class="rounded-circle d-flex align-items-center justify-content-center cursor-pointer service-project ml-2" @click="clickService(index)">
                                        <img class="img-fluid" :src="path">
                                    </div>
                                </div>

                                <div :id="idslickcarousel">
                                    <div v-for="(project, index) in projects">
                                        <img class="img-fluid pr-2" :src="project.field_project_gallery[0]">
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-6 bg-gray" id="project-body">
                                <div class="py-4 px-2 overflow-auto body" v-html="currentproject.body"></div>
                                <div class="arrows">
                                    <i class="fas fa-angle-left fa-3x mr-3 cursor-pointer hvr-pulse" @click="prev()"></i>
                                    <i class="fas fa-angle-right fa-3x ml-3 cursor-pointer hvr-pulse" @click="next()"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-7 p-0">
                        <div id="current-project-gallery">
                            <img v-for="(path, index) in currentproject.field_project_gallery" class="img-fluid" :src="path" v-show="index == indexgallery" :key="'image_' + currentproject.nid + '_' + index">

                            <video controls muted v-for="(path, index) in currentproject.field_video" v-show="(index + currentproject.field_project_gallery.length) == indexgallery" :key="'video_' + currentproject.nid + '_' + index">
                                <source v-if="path" :src="path" type="video/mp4">
                            </video>

                            <iframe v-for="(src, index) in currentproject.field_frame" v-show="(index + currentproject.field_project_gallery.length + currentproject.field_video.length) == indexgallery" :key="'iframe_' + currentproject.nid + '_' + index"
                            :src="src" frameborder='0' allowfullscreen allow='vr'></iframe>

                            <div class="strip-red d-none d-xl-inline-block"></div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else>
                <template v-if="projects.length > 0">
                    <div class="row">
                        <div class="col-12 bg-gray pl-4 pr-0">
                            <div id="current-project-gallery" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner">
                                    <div :class="['carousel-item', {'active': index == 0}]" v-for="(path, index) in currentproject.field_project_gallery">
                                        <img class="img-fluid" :src="path" :key="'image_' + currentproject.nid + '_' + index">
                                    </div>

                                    <div :class="['carousel-item', {'active': index == 0 && currentproject.field_project_gallery.length == 0}]" v-for="(path, index) in currentproject.field_video">
                                        <video controls muted  :key="'video_' + currentproject.nid + '_' + index">
                                            <source v-if="path" :src="path" type="video/mp4">
                                        </video>
                                    </div>

                                    <div :class="['carousel-item', {'active': index == 0 && currentproject.field_project_gallery.length == 0 && currentproject.field_frame.length == 0}]" v-for="(src, index) in currentproject.field_frame">
                                        <iframe :key="'iframe_' + currentproject.nid + '_' + index" :src="src" frameborder='0' allowfullscreen allow='vr'></iframe>
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#current-project-gallery" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#current-project-gallery" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-9 bg-gray pl-4 pr-0">
                            <div class="row">
                                <div class="col-12 px-0 pt-3" v-html="currentproject.body">

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 px-0 py-3">
                                    <div :id="idslickcarousel">
                                        <div v-for="(project, index) in projects">
                                            <img class="img-fluid pr-2" :src="project.field_project_gallery[0]">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-3 py-3 d-flex align-items-end">
                            <div class="arrows">
                                <i class="fas fa-angle-left fa-2x mr-2 cursor-pointer hvr-pulse" @click="prevProject()"></i>
                                <i class="fas fa-angle-right fa-2x ml-2 cursor-pointer hvr-pulse" @click="nextProject()"></i>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "projects",

    data() {
        return {
            idslickcarousel: 'projects-carousel',
            projects: [],
            currentproject: null,
            indexgallery: 0,
            indexproject: 0
        }
    },

    created() {
        axios.get(this.$route.meta.api + "/" + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            var projects = response.data;

            var newProjects = [];
            var i = 0;
            $.each(projects, function(index, value) {
                if(index > 0 && projects[index]['nid'] == newProjects[i-1]['nid']) {
                    newProjects[i-1]['nid_1'].push(projects[index]['nid_1']);
                    newProjects[i-1]['field_servizi_logo_2'].push(projects[index]['field_servizi_logo_2']);
                }
                else {
                    newProjects[i] = projects[index];
                    newProjects[i]['nid_1'] = [value.nid_1];
                    newProjects[i]['field_servizi_logo_2'] = [value.field_servizi_logo_2];
                    newProjects[i]["field_project_gallery"] = value.field_project_gallery.split("|");

                    var arrayVideo = value.field_video.split("|");
                    var arrayFrame = value.field_frame.split("|");
                    newProjects[i]["field_video"] = arrayVideo[0] == "" ? [] : arrayVideo;
                    newProjects[i]["field_frame"] = arrayFrame[0] == "" ? [] : arrayFrame;
                    i += 1;
                }
            });

            this.currentproject = projects[0];
            this.projects = newProjects;

            this.$nextTick(function() {
                this.initSlickCarousel();
                this.viewProjects(true);
            });
        });
    },

    methods: {
        initSlickCarousel() {
            var thisObj = this;
            var slideToShow = 3;

            $('#' + this.idslickcarousel).slick({
                infinite: true,
                arrows: false,
                slidesToShow: slideToShow
            })
            .on('afterChange', function(event, slick, currentSlide) {
                thisObj.$root.animejs.timeline({loop: false})
                .add({
                    targets: '#project-body, #current-project-gallery, footer .bg-gray',
                    opacity: 0,
                    easing: 'linear',
                    duration: 250,
                    complete: function(anim) {
                        thisObj.currentproject = thisObj.projects[currentSlide];
                        thisObj.indexgallery = 0;
                        thisObj.viewProjects();
                    }
                })
                .add({
                    targets: '#project-body, #current-project-gallery, footer .bg-gray',
                    opacity: [0, 1],
                    easing: 'linear',
                    duration: 250
                }, "+=500");
            });

            $("#" + this.idslickcarousel + " .slick-slide img").on("click", function() {
                thisObj.indexproject = $(this).parent().attr("data-slick-index");
                $('#' + thisObj.idslickcarousel).slick("slickGoTo", thisObj.indexproject);
            });            
        },

        next() {
            var thisObj = this;
            var index = this.indexgallery == (this.currentproject.field_project_gallery.length + this.currentproject.field_video.length + this.currentproject.field_frame.length - 1) ? 0 : this.indexgallery + 1;
            this.$root.animejs.timeline({loop: false})
            .add({
                targets: '#current-project-gallery img, #current-project-gallery video, #current-project-gallery iframe',
                opacity: 0,
                easing: 'linear',
                duration: 250,
                complete: function(anim) {
                    thisObj.indexgallery = index;
                }
            })
            .add({
                targets: '#current-project-gallery img, #current-project-gallery video, #current-project-gallery iframe',
                opacity: [0, 1],
                easing: 'linear',
                duration: 250
            }, 250);
        },

        prev() {
            var thisObj = this;
            var index = this.indexgallery == 0 ? (this.currentproject.field_project_gallery.length + this.currentproject.field_video.length + this.currentproject.field_frame.length - 1) : this.indexgallery - 1;
            this.$root.animejs.timeline({loop: false})
            .add({
                targets: '#current-project-gallery img, #current-project-gallery video, #current-project-gallery iframe',
                opacity: 0,
                easing: 'linear',
                duration: 250,
                complete: function(anim) {
                    thisObj.indexgallery = index;
                }
            })
            .add({
                targets: '#current-project-gallery img, #current-project-gallery video, #current-project-gallery iframe',
                opacity: [0, 1],
                easing: 'linear',
                duration: 250
            }, 250);
        },

        prevProject() {
            this.indexproject = this.indexproject == 0 ? this.projects.length - 1 : this.indexproject - 1;
            $('#' + this.idslickcarousel).slick("slickGoTo", this.indexproject);
        },

        nextProject() {
            this.indexproject = this.indexproject == (this.projects.length - 1) ? 0 : this.indexproject + 1;
            $('#' + this.idslickcarousel).slick("slickGoTo", this.indexproject);
        },

        viewProjects(animation = false) {
            var thisObj = this;
            setTimeout(function() {
                if(thisObj.$root.getClassSize() == "xl") {
                    var heightDisplay = $(window).height();
                    var heightFooter = $("footer").height();
                    var position = $("#project-body").offset();
                    var height = heightDisplay - position.top - heightFooter;

                    var positionStrip = $("#strip-red").offset();

                    $("#project-body, #current-project-gallery img, #current-project-gallery video, #current-project-gallery iframe").height(height);

                    var leftImg = position.left + parseFloat($("#project-body").css("width"));
                    var positionStrip = $(".strip-red").offset();
                    var width = positionStrip.left - leftImg;
                    $("#current-project-gallery img, #current-project-gallery video, #current-project-gallery iframe").width(width);

                    var positionCarousel = $("#projects-carousel").offset();
                    $("#current-project-gallery .strip-red").height(positionCarousel.top - position.top + $("#projects-carousel").height());
                    $("#project-body .arrows").css("top", positionCarousel.top - position.top + $("#projects-carousel").height() - $("#project-body .arrows").height() + "px");
                }
                else {
                    $('#current-project-gallery').carousel();
                }

                if(animation) {
                    thisObj.$root.animejs({
                        targets: '#page-case-studies, footer .bg-gray',
                        opacity: [0,1],
                        easing: "easeInOutQuad",
                        duration: 400
                    });
                }
            }, 500);
        },

        clickService(index) {
            this.$emit("goToService", this.currentproject.nid_1[index]);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/projects.vue